module.exports = __webpack_public_path__ + "static/media/dry-van.e697a1ed.svg";